import RouterView from '@@/compose/routerView'

const protocalRouter = {
  path: "/protocal",
  name: "protocal",
  component: RouterView,
  children: [
    {
      path: ":fater_id/:son_id",
      name: "protocal",
      component: () => import("@/views/protocal/_id.vue"),
    },
    {
      path: "publish",
      name: "protocal_publish",
      component: () => import("@/views/protocal/publish.vue"),
    },
    {
      path: "export",
      name: "protocal_export",
      component: () => import("@/views/protocal/export.vue")
    },
    {
      path: "list", // app内嵌-条款和协议
      name: "protocal_list",
      component: () => import("@/views/protocal/list.vue")
    },
    {
      path: "wxapp_pre_list", // 摩点小程序-条款协议&资质证照列表
      name: "wxapp_pre_list",
      component: () => import("@/views/protocal/wxapp_pre_list.vue")
    },
    {
      path: 'rule/:fater_id/:son_id', 
      name: 'protocalRule',
      component: () => import('@/views/protocal/rule.vue')
    },
    {
      path: 'rule/detail/:id', 
      name: 'protocalRuleDetail',
      component: () => import('@/views/protocal/ruleDetail/_id.vue')
    },
    {
      path: 'personal_qualifications/:user_id', 
      name: 'PersonalQualifications',
      component: () => import('@/views/protocal/personal_qualifications/_id.vue')
    },
  ],
};

export default protocalRouter
